import { Base } from '@gate31/core/src/libs/BaseComponent';
import Products from 'Products';
import { InsalesProduct } from '@gate31/feature/InsalesProduct/InsalesProduct';
import { ProductFormActionDesk } from '../ProductFormActionDesk/ProductFormActionDesk';
import { ProductColorDesk } from '../ProductColorDesk/ProductColorDesk';

export class ProductFormDesk extends Base<HTMLFormElement> {
    static cn = new Base.BuildCn('ProductFormDesk');

    product: InsalesProduct;
    RELATED_PRODUCT_BY_COLORS: Array<string>;

    productColorDesk: ProductColorDesk;

    constructor({ node, product }: { node: HTMLFormElement; product: InsalesProduct }) {
        super(node);

        this.product = product;
        this.RELATED_PRODUCT_BY_COLORS = this.getRoot().getAttribute('data-color-product-ids')?.split('||') ?? [];
        this.RELATED_PRODUCT_BY_COLORS.push(String(this.product.id));

        this.productColorDesk = new ProductColorDesk({
            idList: this.RELATED_PRODUCT_BY_COLORS,
            product: this.product
        });

        // eslint-disable-next-line
        new ProductFormActionDesk({
            node: ProductFormActionDesk.querySelector(ProductFormActionDesk.cn.toSelector()),
            product: this.product
        });

        this.configurationOptions();
        this.renderColors();
    }

    configurationOptions() {
        // Помогает приваести опции товара из селекта в радио-кнопки
        Products.setConfig({
            options: {
                Цвет: 'option-radio',
                Размер: 'option-radio'
            },
            initOption: false,
            decimal: 0
        });
    }

    async renderColors() {
        const container = ProductFormDesk.querySelector(ProductFormDesk.cn.setElem('option-values').setMode({ colors: true }).toSelector());
        const content = await this.productColorDesk.renderColorList();

        if (! content) {
            return;
            // todo Возможно показать пользователю что-то?
        }

        container.innerHTML = content;
    }
}
